import * as o from "react";
import i from "../lib/SSRBase.es.js";
import e from "../defs/HandPointing.es.js";
const n = o.forwardRef((t, a) => /* @__PURE__ */ o.createElement(i, { ref: a, ...t, weights: e }));
n.displayName = "HandPointingIcon";
const s = n;
export {
  s as HandPointing,
  n as HandPointingIcon
};
